import styled, { css } from "styled-components";

const shownStyles = css`
  max-height: 80vh;
  visibility: visible;

  .left-overlay__content {
    opacity: 1;
    /* overflow-y: auto;
    overflow-x: hidden; */
    min-height: 20vh;
    max-height: 80vh;
  }
`;

const hiddenStyles = css`
  max-height: 0;
  visibility: hidden;

  .left-overlay__content {
    transition: opacity 1s;
    overflow: hidden;
    opacity: 0;
  }
`;

export const MapLeftOverlayStyled = styled.div`
  width: 270px;
  /* height: max-content;
  max-height: 100%; */
  /* margin: 6px 24px 12px 0; */
  padding: 18px 6px;
  border-radius: 14px;
  background-color: #ffffff;
  overflow: hidden;

  position: absolute;
  left: 0;
  bottom: 0;

  transition: 1s;
  /* transition: opacity 2.5s; */
  ${(props) => (props.show ? shownStyles : hiddenStyles)}
`;
